import { useEffect, useState } from "react";
import { usePathname } from "@/lib/navigation";
import styles from "./LoadingSpinner.module.css";

export default function LoadingSpinner() {
  const [isLoading, setIsLoading] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <div
      className={`${styles.loadingOverlay} ${isLoading ? styles.visible : ""}`}
    >
      <div className={styles.spinner} />
    </div>
  );
}
